export const environment = {
  production: false,
  apiBaseUrl: 'https://ai-codereview-dev-api.app.invento.io',
  auth: {
    // Set these from the Azure Portal app registrations.
    // tenantId   = the directory (tenant) id of the invento.sa tenant
    // clientId   = SPA app registration's "Application (client) ID"
    // apiScopes  = the scope you exposed on the API app registration,
    //              format: ["api://<api-client-id>/access_as_user"]
    tenantId: '078adcd6-148f-44ee-8d90-38acb49150a6',
    clientId: '27f01879-9029-49b8-904e-41bc77918468',
    // Production-only — the "-dev" suffix is just the historical hostname,
    // this is the real production dashboard URL. Same value in both env files.
    redirectUri: 'https://ai-codereview-dev.app.invento.io',
    apiScopes: ['api://27f01879-9029-49b8-904e-41bc77918468/access_as_user'],
  },
};
